module.exports = __webpack_public_path__ + "static/7-parallel-universes-530798ac219eabf2bd2b4bb3763d37bb.svg";